// extracted by mini-css-extract-plugin
export default {"superAdmin":"AdminUsersForm_superAdmin__i5hck","table":"AdminUsersForm_table__M97cD","deleteButton":"AdminUsersForm_deleteButton__FKAqS"};